<template>
  <div>
    <v-row class="mb-3">
      <v-col cols="12" md="6">
        <v-text-field
          type="text"
          label="Kode Container"
          outlined
          dense
          hide-details
          :loading="loading.isLoadingFetchKV"
          v-model="kc"
          @keydown.enter="fetchKV"
          @blur="fetchKV"
        >
        </v-text-field>
      </v-col>
      <v-col cols="12" md="6">
        <v-select
          :items="items.kv"
          :loading="loading.isLoadingFetchKV"
          @change="fetchData"
          label="Kode Vessel (KV)"
          outlined
          dense
          hide-details
          v-model="kv"
        >
        </v-select>
      </v-col>
    </v-row>

    <main class="report" id="section-print">
      <table width="100%" class="mb-2">
        <thead>
          <th width="5%">KS</th>
          <th width="25%">KC / No Container</th>
          <th width="25%">KodeTTB / No TTB</th>
          <th width="10%">Koli In</th>
          <th width="20%">Nama Langganan</th>
          <th width="15%">Cargo</th>
        </thead>
        <tbody v-if="items.ks.length > 0">
          <tr v-for="ks in items.ks" :key="ks.id">
            <td>{{ ks.ks }}</td>
            <td>{{ ks.container.kc }} / {{ ks.container.no_container }}</td>
            <td>{{ ks.ttb.kodettb }} / {{ ks.ttb.nottb }}</td>
            <td>{{ ks.koli_in }}</td>
            <td>{{ ks.ttb.penerima_detil.nama }}</td>
            <td>{{ ks.container.cargo }}</td>
          </tr>
        </tbody>
        <tfoot v-if="items.ks.length == 0">
          <tr>
            <td colspan="6" class="text-center">No Data</td>
          </tr>
        </tfoot>
      </table>
    </main>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data: () => ({
    kc: "",
    kv: "",
    items: {
      kv: [],
      ks: []
    },
    loading: {
      isLoadingFetchKV: false,
      isLoadingFetchKS: false
    }
  }),
  methods: {
    fetchKV() {
      this.loading.isLoadingFetchKV = true;

      if (!this.kc) {
        this.items.kv = [];
        this.kv = "";
        this.items.ks = [];

        this.loading.isLoadingFetchKV = false;

        return;
      }

      axios
        .get(`get-kv-by-kc?kc=${encodeURIComponent(this.kc)}`)
        .then(response => {
          this.items.kv = response.data;
          this.kv = this.items.kv.length > 0 ? this.items.kv[0] : "";

          this.fetchData();

          this.loading.isLoadingFetchKV = false;
        })
        .catch(error => {
          this.loading.isLoadingFetchKV = false;
        });
    },
    fetchData() {
      this.loading.isLoadingFetchKS = true;

      const params = new URLSearchParams({
        kc: this.kc
      });

      if (this.kv !== null && this.kv !== "") {
        params.append("kv", this.kv);
      }

      axios
        .get(`get-ks?${params.toString()}`)
        .then(response => {
          this.items.ks = response.data;

          this.loading.isLoadingFetchKS = false;
        })
        .catch(error => {
          this.loading.isLoadingFetchKS = false;
        });
    }
  }
};
</script>

<style scoped>
.report {
  background-color: white;
  width: 100%;
  font-family: times;
  padding: 20px;
  color: black;
}

table {
  border-bottom: 1px solid black;
}

table th {
  text-align: left;
}
</style>
